import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    this.allowSignOut = this.allowSignOut.bind(this);
    window.addEventListener("beforeunload", this.areYouSure);
    document.addEventListener("click", this.allowSignOut, true);
  }

  disconnect() {
    window.removeEventListener("beforeunload", this.areYouSure);
    document.removeEventListener("click", this.allowSignOut, true);
  }

  allowSignOut(e) {
    if (e.target.closest("[data-skip-confirm-leave]")) {
      window.removeEventListener("beforeunload", this.areYouSure);
    }
  }

  areYouSure(e) {
    e.preventDefault();
    return "";
  }
}
